import { render, staticRenderFns } from "./phone-number-field.vue?vue&type=template&id=4f7a4e03"
import script from "./phone-number-field.vue?vue&type=script&lang=js"
export * from "./phone-number-field.vue?vue&type=script&lang=js"
import style0 from "./phone-number-field.vue?vue&type=style&index=0&id=4f7a4e03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports